// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"381":"2866bc73","509":"f73ff87c","643":"aa227523","661":"f857877d","863":"d55b57d3"}[chunkId] + ".chunk.css";
};